<template>
  <div class="min-h-screen">
    <div v-if="!showTeamMember">
      <div class="bg-white m-3 rounded-md">
        <div class="border-b-0.5 flex justify-between items-center p-3">
          <p class="text-sm font-semibold">Pending Training Requests</p>

          <div>
            <button
              @click="showAssignTraining = true"
              class="bg-primary text-white rounded-full text-sm h-10"
            >
              Assign Training
            </button>
          </div>
        </div>

        <transition name="fade">
          <div
            v-if="loading"
            class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
          >
            <loader class="center-h-v" />
          </div>
        </transition>

        <div class="" v-if="pendingTrainings.length">
          <div class="flex items-left my-2 mb-3">
            <el-pagination
              background
              @size-change="handleSizeChange"
              :page-sizes="pageSizes"
              :page-index="pageIndex"
              :page-size="pageSize"
              layout="sizes"
              :total="totalCount()"
            >
            </el-pagination>

            <!-- search -->
            <input
              v-model="searchInput"
              type="search"
              placeholder="Start typing to search..."
              class="bg-gray-200 w-52 py-2 rounded-md"
            />
            <!-- search -->
          </div>

          <div>
            <ve-table
              v-if="searchInput"
              :columns="columns"
              :tableData="pendingTrainings"
              :event-custom-option="eventCustomOption"
              sort-order="asc"
            />

            <ve-table
              v-if="!searchInput"
              :columns="columns"
              :tableData="pendingTrainings"
              :event-custom-option="eventCustomOption"
              sort-order="asc"
            />

            <p
              v-if="searchInput.length && pendingTrainings.length === 0"
              class="text-center py-3"
            >
              No results
            </p>

            <p
              v-if="pendingTrainings.length === 0 && !loading"
              class="p-1 text-center text-sm w-full bg-gray-100"
            >
              No Training found
            </p>
          </div>
        </div>

        <!-- Pagination -->
        <div class="table-pagination text-center mt-2">
          <el-pagination
            v-if="pendingTrainings?.length > 0"
            background
            layout="prev, pager, next"
            :total="totalCount()"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
          >
            <!-- :current-page.sync="currentPage4" -->
          </el-pagination>
          <p v-if="pendingTrainings?.length === 0" class="text-center py-3">
            No Training
          </p>
        </div>
      </div>
    </div>

    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">Training History</p>
      </div>

      <div class="">
        <el-tabs type="border-card" @tab-click="(e) => setTab(e)">
          <el-tab-pane
            v-for="(tab, index) in tabs"
            :key="index"
            :label="tab.name"
          >
            <div class="" v-if="filteredTrainingHistories.length && !loading">
              <div class="flex items-left my-2 mb-3">
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  :page-sizes="pageSizes"
                  :page-index="pageIndex"
                  :page-size="pageSize"
                  layout="sizes"
                  :total="filteredTrainingHistories.length"
                >
                </el-pagination>

                <!-- search -->
                <input
                  v-model="searchInput2"
                  type="search"
                  placeholder="Start typing to search..."
                  class="bg-gray-200 w-52 py-1 rounded-md"
                />
                <!-- search -->
              </div>

              <div>
                <ve-table
                  v-if="searchInput2"
                  :columns="columns.slice(0, -2)"
                  :tableData="filteredTrainingHistories"
                  :event-custom-option="eventCustomOption"
                  sort-order="asc"
                />

                <ve-table
                  :columns="columns.slice(0, -2)"
                  :tableData="filteredTrainingHistories"
                  :event-custom-option="eventCustomOption"
                  v-if="!searchInput2.length"
                >
                </ve-table>

                <p
                  v-if="searchInput2.length && filteredTableData2.length === 0"
                  class="text-center py-3"
                >
                  No results
                </p>
                <!-- Pagination -->
                <div class="table-pagination text-center mt-2">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="filteredTrainingHistories.length"
                    :page-size="pageSize"
                    @current-change="handleCurrentChange"
                  >
                    <!-- :current-page.sync="currentPage4" -->
                  </el-pagination>
                </div>
                <!-- Pagination -->
              </div>
            </div>
            <p v-else class="text-center p-3 text-sm w-full bg-gray-100">
              No Training found
            </p>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div v-if="showTeamMember">
      <team-member @backToTeam="showTeamMember = false"></team-member>
    </div>
    <leave-decline-reason
      :showAddReason="showAddReason"
      :setReason="setReason"
      @close="handleClose"
    >
    </leave-decline-reason>

    <approval-warning
      :show-approval-warning="showApprovalWarning"
      :setIsConfirmed="setIsConfirmed"
      @close="showApprovalWarning = false"
    >
    </approval-warning>

    <review-training
      :show-review-leave="showReviewLeave"
      @close="showReviewLeave = false"
      :approvalEntries="approvalEntries"
      :leaveDetails="leaveDetails"
    ></review-training>
    <AssignTrainingVue
      @close="showAssignTraining = false"
      :show-assign-training="showAssignTraining"
      @record-created = "getTeamTrainings('Approved')"
    ></AssignTrainingVue>
  </div>
</template>

<script>
import axios from "axios";
import TeamMember from "./teamMember.vue";
import LeaveDeclineReason from "./addReason.vue";
import ApprovalWarning from "./approvalWarning.vue";

import ReviewTraining from "./reviewTraining.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import Loader from "@/components/loader/loader.vue";
import AssignTrainingVue from "./assignTraining.vue";
import decryptData from "@/utils/decrypt";
export default {
  name: "TeamTimeOff",
  props: ["showDetails"],
  components: {
    TeamMember,
    LeaveDeclineReason,
    ReviewTraining,
    ApprovalWarning,
    Loader,
    AssignTrainingVue,
  },
  data() {
    return {
      tableData: [],
      filteredTrainingHistories: [],
      approvedTrainings: [],
      declinedTrainings: [],
      canceledTrainings: [],
      pendingTrainings: [],
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      RowId: null,
      showLeaveApplicationModal: false,
      approval: [],

      showAttachments: false,
      showAssignTraining: false,
      attachmentUrl: null,
      showRequestLeave: false,
      reason: null,
      message: null,
      create_error: null,
      showTeamMember: false,
      isApproved: false,
      isDeclined: false,
      isConfirmed: false,
      approveMessage: null,
      declineMessage: null,
      showAddReason: false,
      approvalEntries: null,
      leaveDetails: null,
      showReviewLeave: false,
      showApprovalWarning: false,
      rowToApprove: null,
      searchInput: "",
      searchInput2: "",
      selectedTab: "Approved",
      currentTab: "Approved",
      teamKey: 0,
      mineKey: 1,
      get_error: null,
      loading: false,
      eventCustomOption: {
        bodyRowEvents: ({ row }) => {
          return {
            click: (event) => {
              if (!(event.target instanceof SVGSVGElement)) {
                this.showDetails(row);
              }
            },
            dblclick: () => {
              if (!(event.target instanceof SVGSVGElement)) {
                this.showDetails(row);
              }
            },
            contextmenu: () => {},
            mouseenter: () => {},
            mouseleave: () => {},
          };
        },
      },
      tabs: [
        {
          name: "Approved",
          route: "team-approved",
        },
        {
          name: "Declined",
          route: "team-declined",
        },
        {
          name: "Canceled",
          route: "team-canceled",
        },
      ],

      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 50,
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "Name",
          title: "Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "StartDate",
          key: "StartDate",
          title: "From",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.StartDate)}</p>
          ),
        },
        {
          field: "EndDate",
          key: "EndDate",
          title: "To",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.EndDate)}</p>
          ),
        },
        {
          field: "Urgency",
          key: "urgency",
          title: "Urgency",
          renderBodyCell: ({ row }) => {
            let status = "";

            switch (row.Urgency) {
              case "Mild":
                status = (
                  <p class="cursor-pointer rounded bg-green-100 text-green-500">
                    {" "}
                    {row.Urgency}
                  </p>
                );
                break;

              case "Trivial":
                status = (
                  <p class="cursor-pointer rounded bg-blue-100 text-blue-500">
                    {row.Urgency}
                  </p>
                );
                break;
              case "Urgent":
                status = (
                  <p class="cursor-pointer bg-red-100 rounded text-red-500">
                    {row.Urgency}
                  </p>
                );
                break;
            }
            return status;
          },
        },
        {
          field: "Source",
          key: "source",
          title: "Source",
          align: "left",
          width: 150,
          ellipsis: {
            showTitle: true,
          },

          renderBodyCell: ({ row }) => {
            // console.log(row);
            const urlPattern =
              /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/;
            if (urlPattern.test(row.Source)) {
              return (
                <el-popover
                  placement="top-start"
                  title={"Training request from " + row.Name}
                  width="300"
                  trigger="hover"
                  content={row.Source}
                >
                  <a
                    class="text-blue-900 cursor-pointer"
                    slot="reference"
                    styel="font-size: 0.68rem !important;"
                    href={row.Source}
                    target="_blank"
                  >
                    {row.Source}
                  </a>
                </el-popover>
              );
            } else {
              return (
                <el-popover
                  placement="top-start"
                  title={"Training request from " + row.Name}
                  width="300"
                  trigger="hover"
                  content={row.Source}
                >
                  <p
                    slot="reference"
                    class="cursor-pointer"
                    styel="font-size: 0.68rem !important;"
                  >
                    {row.Source}
                  </p>
                </el-popover>
              );
            }
          },
        },

        {
          field: "CreatedBy",
          key: "createdBy",
          title: "Created By",
          headerAlign: "left",

          ellipsis: {
            showTitle: true,
          },

          renderBodyCell: ({ row }) => {
            return (
              <el-popover
                placement="top-start"
                title={"Training request from " + row.Name}
                width="300"
                trigger="hover"
                content={decryptData(row.CreatedBy, this.$decryptionKey)}
              >
                <p
                  slot="reference"
                  class="cursor-pointer"
                  styel="font-size: 0.68rem !important;"
                >
                  {decryptData(row.CreatedBy, this.$decryptionKey)}
                </p>
              </el-popover>
            );
          },
        },

        {
          field: "ApprovedBy",
          key: "approvedBy",
          title: "Approver",
          headerAlign: "left",

          ellipsis: {
            showTitle: true,
          },

          renderBodyCell: ({ row }) => {
            return (
              <el-popover
                placement="top-start"
                title={"Training approved by " + row.Name}
                width="300"
                trigger="hover"
                content={decryptData(row.ApprovedBy, this.$decryptionKey)}
              >
                <p
                  slot="reference"
                  class="cursor-pointer"
                  styel="font-size: 0.68rem !important;"
                >
                  {decryptData(row.ApprovedBy, this.$decryptionKey)}
                </p>
              </el-popover>
            );
          },
        },

        {
          field: "Description",
          key: "Description",
          title: "Description",
          headerAlign: "left",
          align: "left",
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Training request from " + row.Name}
              width="300"
              trigger="hover"
              content={row.Description}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.Description}
              </p>
            </el-popover>
          ),
        },

        {
          field: "Status",
          key: "Status",
          title: "Status",
          renderBodyCell: ({ row }) => {
            let status = "";

            switch (row.Status) {
              case "Approved":
                status = (
                  <p class="cursor-pointer rounded bg-green-100 text-green-500">
                    {row.Status}
                  </p>
                );
                break;

              case "Pending":
                status = (
                  <p class="cursor-pointer rounded bg-blue-100 text-blue-500">
                    {row.Status}
                  </p>
                );
                break;
              case "Declined":
                status = (
                  <p class="cursor-pointer rounded bg-red-100 text-red-500">
                    {row.Status}
                  </p>
                );
                break;
            }
            return status;
          },
        },
        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => {
                    this.showDetails(row);
                  }}
                >
                  View
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.approveTraining(row)}
                >
                  Approve
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.declineTraining(row)}
                >
                  Decline
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      columns2: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "Name",
          title: "Name",
          align: "left",
          width: "15%",
          renderBodyCell: ({ row }) => {
            return (
              <div
                on-click={() => {
                  this.attachmentUrl = row.Attachment;
                  this.approvalEntries = row.ApprovalEntries;
                  this.leaveDetails = row;
                  this.showReviewLeave = true;
                  this.showAttachments = true;
                }}
                class="flex gap-5 items-center"
              >
                <div class="h-8 w-8 rounded-full">
                  <img
                    class="h-full w-full rounded-full"
                    src="https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png"
                  />
                </div>
                <p class="text-blue-500 cursor-pointer">{row.Name}</p>
              </div>
            );
          },
        },
        {
          field: "LeaveType",
          key: "LeaveType",
          title: "Type",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "StartDate",
          key: "StartDate",
          title: "From",
          align: "left",
          headerAlign: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.EndDate)}</p>
          ),
          ellipsis: {
            showTitle: true,
          },
        },
        {
          field: "To",
          key: "To",
          title: "To",
          align: "left",
          headerAlign: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.EndDate)}</p>
          ),
          ellipsis: {
            showTitle: true,
          },
        },
        { field: "Period", key: "Period", title: "Days" },

        {
          field: "Description",
          key: "Description",
          title: "Description",
          align: "left",
          headerAlign: "left",
        },
      ],

      approversColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Approver",
          key: "Approver",
          title: "Approver",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "Sequence",
          key: "Sequence",
          title: "Sequence",
          align: "center",
          headerAlign: "center",
        },
        {
          field: "ProcessedDate",
          key: "DateProcessed",
          title: "Date Processed",
          align: "left",
          headerAlign: "left",
          renderBodyCell: ({ row }) => {
            return row.ProcessedDate
              ? moment(row.ProcessedDate).format("DD/MM/YYYY")
              : "";
          },
        },
        {
          field: "Status",
          key: "Status",
          title: "Status",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "Reason",
          key: "Reason",
          title: "Reason",
          align: "left",
          headerAlign: "left",
        },
      ],

      expandOption: {
        render: ({ row, column, rowIndex }, h) => {
          // this.selectedRow = row;
          row, column, rowIndex, h;
          const { ApprovalEntries } = row;

          return (
            <div class="my-2">
              <div class="border-b-0.5 flex justify-between items-left pb-2">
                <p class="text-sm font-semibold w-full">Leave Approvers</p>
              </div>
              <ve-table
                columns={this.approversColumns}
                table-data={ApprovalEntries}
                sort-order="asc"
                row-key-field-name="SubDepartmentId"
              />
              {ApprovalEntries.length === 0 ? (
                <p class="p-1 text-center text-sm w-full bg-gray-100 text-center">
                  No Sub-departments found for {row.Name}
                </p>
              ) : null}
            </div>
          );
        },
      },
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken", "getUserRole"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return [];
        // this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return [].filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },

    watch: {
      filteredTrainingHistories: {
        handler(newVal) {
          if (newVal.length > 0) {
            const { LeaveTypeId } = newVal[0];
            this.filteredTrainingHistories(LeaveTypeId);
          }
        },
        immediate: true,
      },
    },

    filteredColumns() {
      const approvedCount = this.leaves.filter(
        (leave) => leave.Status === "Approved"
      ).length;
      const declinedCount = this.leaves.filter(
        (leave) => leave.Status === "Declined"
      ).length;

      return this.columns.filter((column) => {
        if (
          column.field === "Action" &&
          (approvedCount === this.leaves.length ||
            declinedCount === this.leaves.length)
        ) {
          return false;
        }
        return true;
      });
    },
  },
  created() {
    this.setTab();
    this.getTeamTrainings(this.currentTab);
    this.updateTrainingList(this.currentTab);
  },
  methods: {
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    setTab(event) {
      let id = event ? event["$el"].id : "pane-0";
      switch (id) {
        case "pane-0":
          this.updateTrainingList("Approved");
          break;
        case "pane-1":
          this.updateTrainingList("Declined");
          break;
        case "pane-2":
          this.updateTrainingList("Canceled");
          break;
      }
    },
    setIsConfirmed() {
      this.isConfirmed = true;
      this.approveLeave(this.rowToApprove);
    },
    showLeaveApplication() {
      if (this.showLeaveApplicationModal) {
        this.showLeaveApplicationModal = false;
      } else {
        this.showLeaveApplicationModal = true;
      }
    },
    closeLeaveApplicationModal() {
      this.showLeaveApplicationModal = false;
    },

    viewTeamMember() {
      this.showTeamMember = true;
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      return date.toLocaleDateString("en-US", options);
    },
    setReason(reason) {
      const data = {
        Id: this.RowId,
        Reason: reason,
        Status: "Declined",
      };
      this.submit(data);
    },
    // /{organization}/training/team/v1/query
    getTeamTrainings() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/training/team/${this.$ApiVersion}/query`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            console.log(response.data.Data)
            if (response.status == 200) {
              this.pendingTrainings = response.data.Data.filter(
                (training) => training.Status === "Pending"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));

              this.cancelledTrainings = response.data.Data.filter(
                (training) => training.Status === "Cancelled"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));

              this.approvedTrainings = response.data.Data.filter(
                (training) => training.Status === "Approved"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));

              this.declinedTrainings = response.data.Data.filter(
                (training) => training.Status === "Declined"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));

              this.updateTrainingList("Approved");
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    // /{organization}/training/v1/approve

    approveTraining({ TrainingId }) {
      const data = {
        TrainingId,
        Status: "Approved",
      };
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .post(
          `${this.getOrganization}/training/${this.$ApiVersion}/approve`,
          data,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode === 200) {
              this.$notify({
                title: "Success",
                message: response.data.StatusMessage,
                type: "success",
              });
              this.getTeamTrainings();
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;

            this.$notify.error({ title: "Success", message: error.message });
          }
        );
    },

    declineTraining() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/training/${this.$ApiVersion}/approve`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status == 200) {
              this.tableData = response.data.Data.filter(
                (timeoff) => timeoff.Status === "Pending"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));

              this.canceledAndDeclinedLeaves = response.data.Data.filter(
                (timeoff) => timeoff.Status !== "Pending"
              ).sort((a, b) => new Date(a.StartDate) - new Date(b.StartDate));
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    updateTrainingList(currentTab) {

      this.currentTab = currentTab;
      switch (currentTab) {
        case "Approved":
          this.filteredTrainingHistories = this.approvedTrainings;
          break;
        case "Canceled":
          this.filteredTrainingHistories = this.canceledTrainings;
          break;

        case "Declined":
          this.filteredTrainingHistories = this.declineTrainings;
          break;

        default:
          break;
      }
    },
    approveLeave({ Id, Reason }) {
      const data = {
        Id,
        Reason: Reason,
        Status: "Approved",
      };
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      this.showApprovalWarning = false;

      this.loading = true;

      axios
        .post(
          `${this.getOrganization}/timeoff/${this.$ApiVersion}/process`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              // this.$emit("closeOnSuccess");
              this.getTeamTrainings();

              this.tableData = [];
              this.message = response.data.StatusMessage;
              setTimeout(() => {
                this.isApproved = true;
                this.message = null;
              }, 3000);
            } else {
              this.create_error = response.data.StatusMessage;
              this.getTeamTrainings();
              setTimeout(() => {
                this.create_error = null;
              }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 3000);
          }
        );
    },

    declineLeave({ Id }) {
      this.showAddReason = true;
      this.loading = true;
      this.RowId = Id;
    },

    submit(data) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      // alert(this.getOrganization);
      if (data.Reason) {
        this.loading = true;
        this.showAddReason = false;
        axios
          .post(
            `${this.getOrganization}/timeoff/${this.$ApiVersion}/process`,
            JSON.stringify(data),
            options
          )
          .then(
            (response) => {
              //console.log(response.data);
              this.loading = false;
              if (response.status == 200) {
                this.$emit("closeOnSuccess");
                this.getTeamTrainings();
                this.tableData = response.data.Data;
                this.declineMessage = response.data.StatusMessage;
                setTimeout(() => {
                  this.isDeclined = true;
                  this.declineMessage = null;
                }, 3000);
              } else {
                this.getTeamTrainings();
                this.create_error = response.data.StatusMessage;
              }
            },
            (error) => {
              this.loading = false;
              this.create_error = error.message;
            }
          );
      } else {
        this.create_error = "Reason for declination missing";
      }
    },

    handleClose() {
      this.showAddReason = false;
      this.showApprovalWarning = false;
    },

    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
};
</script>
<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 0px;
}
</style>
